<template>
    <div
        v-if="isDisplay"
        class="sidebar-link"
    >

        <a
            v-if="href"
            :href="href"
            target="_blank"
            @click="clickAction()"
        >
            <el-menu-item
                :index="index"
                class="is-inactive"
            >
                <i :class="i"></i>
                <span v-if="!(burgerMenuAllowedAndClosed)">{{ name }}</span>
            </el-menu-item>
        </a>

        <router-link
            v-else-if="to"
            :key="index"
            :to="{ name: to}"
            tag="div"
            @click="clickAction()"
        >
            <el-menu-item
                :index="index"
                :class="[$route.name === to ? 'is-active': 'is-inactive']"
            >
                <i :class="i"></i>
                <span v-if="!(burgerMenuAllowedAndClosed)">{{ name }}</span>
            </el-menu-item>
        </router-link>

        <el-menu-item
            v-else
            :index="index"
            class="is-inactive"
            @click="clickAction()"
        >
            <i :class="i"></i>
            <span v-if="!(burgerMenuAllowedAndClosed)">{{ name }}</span>
        </el-menu-item>

    </div>
</template>

<script>
/*

Pour l'instant :

<template v-for="(menuLink, index) in menuOptions">
    <sidebar-link :menuLink="menuLink" :key="index"></sidebar-link>
</template>

*/


import {mapGetters} from 'vuex';
export default {
    name: 'SidebarLink',
    props: {
        i:{
            type: String,
            default() {
                return 'ti-line-double';
            }
        },
        index:{
            type: String,
            required: true,
        },
        name:{
            type: String,
            required: true,
        },
        href:{
            type: String,
            required: false,
            default() {
                return '';
            }
        },
        to:{
            type: String,
            required: false,
            default() {
                return '';
            }
        },
        isDisplay: {
            type: Boolean,
            default: true,
        },
        clickAction:{
            type: Function,
            required: false,
            default(){
                return () => {};
            }
        },
    },

    data (){
        return {
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
        ]),
    }
};
</script>

<style lang="scss" >
.sidebar-link{
    .el-menu-item {
        &.is-active{
            i, span{
                color: #ffd04b;
            }
        }
        &.is-inactive{
            i{
                color: #909399;
            }
            span{
                color: #ffffff;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/sidebarLink.vue